import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import {
  MassTextApprovalDecision,
  MassTextApprovalQueueItem,
} from '@chiroup/core/types/MassText.type';

export type BulkCampaignApprovalQueue = {
  data: MassTextApprovalQueueItem[];
  count: number;
};

const bulkCampaignApprovalsService = () => {
  const list = async (clinicId?: number | null): Promise<BulkCampaignApprovalQueue> => {
    return ChiroUpAPI.get('api', '/campaign-approvals/bulk-sms', {
      queryParams: clinicId ? { clinicId } : {},
    });
  };

  const decide = async (
    clinicId: number,
    campaignId: number,
    body: MassTextApprovalDecision
  ): Promise<BulkCampaignApprovalQueue> => {
    return ChiroUpAPI.post('api', `/campaign-approvals/bulk-sms/${clinicId}/${campaignId}`, {
      body,
    });
  };

  return { list, decide };
};

export default bulkCampaignApprovalsService();
